import React from "react";
import closebtn from "../../assets/images/close.svg";
import crossarrow from "../../assets/images/crossarrow.svg";
import network from "../../assets/images/network.svg";
import { Link } from "react-router-dom";

function LearnMorePopup({ handleshowPopup, title }) {
  return (
    <>
      <div className="schedular-popup password-locker-popup">
        <div className="popup-title">
          <h2>{title}</h2>
          <img
            src={closebtn}
            alt="close"
            id="learn-more"
            className="cursor-pointer"
            onClick={(e) => {
              handleshowPopup(e);
            }}
          />
        </div>
        <div className="popup-body">
          <div className="d-flex gap-3 align-items-start">
            <img src={network} alt="network" />
            <p>
              You haven’t created any cost allocation tags or cost categories
              You haven’t created any cost allocation tags or cost categoriesYou
              haven’t created any cost allocation tags or cost categoriesYou
              haven’t created any cost allocation tags or cost categoriesYou
              haven’t created any cost allocation tags or cost categoriesYou
              haven’t created any cost allocation tags or cost categoriesYou
              haven’t created any cost allocation tags or cost categoriesYou
              haven’t created any cost allocation tags or cost categoriesYou
              haven’t created any cost allocation tags or cost categoriesYou
              haven’t created any cost allocation tags or cost categoriesYou
              haven’t created any cost allocation tags or cost categoriesYou
              haven’t created any cost allocation tags or cost categoriesYou
              haven’t created any cost allocation tags or cost categoriesYou
              haven’t created any cost allocation tags or cost categoriesYou
              haven’t created any cost allocation tags or cost categories.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default LearnMorePopup;
